module.exports = __webpack_public_path__ + "static/media/How can I link file notes with the Visa types.e56ace02.png";